export default __webpack_public_path__ + "static/media/Connecticut4Closed.054025fa.jpg";